import { render } from "./AttendanceDashboard.vue?vue&type=template&id=e31067d4&scoped=true"
import script from "./AttendanceDashboard.vue?vue&type=script&lang=js"
export * from "./AttendanceDashboard.vue?vue&type=script&lang=js"

import "./AttendanceDashboard.vue?vue&type=style&index=0&id=e31067d4&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/SIMI-TRAC/SIMI-TRAC-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e31067d4"]])

export default __exports__